<template>
	<div class="title-sidebar">
		<div v-if="!title" class="blocking-element" style="width: 100%; padding-top: 142%"></div>
		<aside v-else>
			<div class="title-sidebar">
				<TitleDetailPosterWithInfo
					:showChartInfo="showChartInfo"
					:streamingChartInfo="streamingChartInfo"
					:title="title"
				>
					<slot></slot>
				</TitleDetailPosterWithInfo>

				<!-- <TextRecommendationInfo
					class="text-recommendations"
					:watchedByCount="title.watchedByCount"
					:recommendedByCount="title.recommendedByCount"
				/> -->

				<TitleDetailQuickActionBarV1
					v-if="title && showQuickAction"
					class="title-sidebar__quick-action-bar"
					:class="{
						'hide-sm': isLoggedIn,
					}"
					:titleObject="title"
					:titleContentType="titleContentType"
					:influencedSponsoredAd="influencedSponsoredAd"
				/>

				<TitleDetailSideInfos
					v-if="title && showTitleInfo"
					:title="title"
					:hasStreamingChart="!!(showChartInfo && streamingChartInfo)"
					:itemStartAt="2"
				/>

				<slot name="streamingCharts" />

				<div class="title-sidebar__jump-links">
					<slot name="jump-links"></slot>
					<AdUnit
						v-if="showAd"
						adPosition="under_detail_info"
						:subgenres="title.content.subgenres"
						:additionalContexts="additionalContexts"
					/>
				</div>
			</div>
		</aside>
	</div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

import AdUnit from '@/components/AdUnit.vue';
import TitleDetailSideInfos from '@/pages/titleDetailV1/v1/sidebar/TitleDetailSideInfos.vue';
import TitleDetailQuickActionBarV1 from '@/pages/titleDetailV1/v1/sidebar/TitleDetailQuickActionBarV1.vue';
import TitleDetailPosterWithInfo from '@/pages/titleDetailV1/v1/sidebar/TitleDetailPosterWithInfo.vue';

import { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';

import { TitleContentType } from '@/interfaces/snowplow/title-context';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import type { SponsoredAdFragment } from '@/features/sponsored-recommendations/graphql/fragments/SponsoredAd.fragment';
import { useMounted, useWindowSize } from '@vueuse/core';
import { useUserStore } from '@/stores/pinia/useUserStore';
import { storeToRefs } from 'pinia';

const props = withDefaults(
	defineProps<{
		additionalContexts?: SnowplowContext[];
		title: TitleDetail;
		titleContentType?: TitleContentType;
		influencedSponsoredAd?: SponsoredAdFragment | undefined;
		showPoster?: boolean;
		showTitleInfo?: boolean;
		showQuickAction?: boolean;
		showChartInfo?: boolean;
	}>(),
	{
		additionalContexts: () => [],
		influencedSponsoredAd: undefined,
		showPoster: true,
		showTitleInfo: true,
		showQuickAction: true,
		showChartInfo: true,
		titleContentType: undefined,
	}
);

const { width } = useWindowSize();
const mounted = useMounted();
const { isLoggedIn } = storeToRefs(useUserStore());

const streamingChartInfo = computed(() => {
	return props.title?.streamingCharts?.edges?.[0].streamingChartInfo ?? null;
});

const showAd = computed(() => mounted.value && width.value > 1050);
</script>

<style lang="scss">
@import '~@/styles/variables.scss';
@import '~@/styles/rtl-support-mixins.scss';

.title-sidebar {
	.title-info {
		margin-top: 20px;
		padding-top: 20px;
		border-top: 1px solid $jw-color-darkgray;
	}
	.sync-watchList-btn {
		background-color: #303740 !important;
		min-height: 48px;
	}
	&__quick-action-bar {
		&.hide-sm {
			@media screen and (max-width: 1050px) {
				display: none;
			}
		}
	}
}

.text-recommendations {
	margin-bottom: 16px;
}
</style>
